<template>
  <v-flex>
    <router-link :to="{name:'home'}">
      <v-avatar :tile="true" :size="40" color="grey lighten-3 elevation-0">
        <img :src="logoUrl" :alt="'Logo ' + system.cardName.mianownik" />
      </v-avatar>

      <span class="city-card">{{ system.cardName.mianownik }}</span>
    </router-link>
  </v-flex>
</template>

<script>
import { mapState } from 'vuex';

import store from '@/store/store';
import { config } from '@/utils/config';

// @vuese
// Logo
// @group MainLayout
export default {
  beforeCreate() {
    store.dispatch('settings/get', 'PUBLIC_LOGO').catch(err =>
      store.dispatch('notifyError', {
        title: 'Wystąpił błąd podczas pobierania ustawień.',
        messages: [err.message || err]
      })
    );
  },
  computed: mapState({
    system: state => state.system,
    logoUrl(state) {
      if (state.settings.PUBLIC_LOGO && state.settings.PUBLIC_LOGO.value) {
        return `${config.mediaURL}/${state.settings.PUBLIC_LOGO.value}`;
      }
      return '/img/main_image.jpg';
    }
  })
};
</script>

<style>
.router-link-active {
  text-decoration: none;
}
</style>
